import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { PreferredTimePopupModal } from './PreferredTimePopupModal.js';

var PreferredTimePopupModalContainer = (_param)=>{
    var { items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "items"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.preferredTimePopupModal.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(PreferredTimePopupModal, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    }));
};

export { PreferredTimePopupModalContainer, PreferredTimePopupModalContainer as default };
//# sourceMappingURL=PreferredTimePopupModalContainer.js.map
